import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import util from './utils/utils';
import { ConfigProvider } from './contexts/ConfigContext';
import Layouts from './layouts';
import Routes from './routers';
import { RecoilRoot } from 'recoil';
import { ErrorBoundary } from './components/ErrorBoundary/index.jsx';
import RouterQuery from './components/RouterQuery/index.jsx';
import './App.css'
import { StoreProvider } from './views/Policy/StoreContext.js';
import { AnimationProvider } from './components/AnimationProvider/index.jsx';

// ✅ 动态获取basename配置
const getBasename = () => {
  // 如果是grid-build模式且有DOMAIN配置，提取basename
  if (process.env.REACT_APP_TYPE === 'grid-build' && process.env.REACT_APP_DOMAIN) {
    const domain = process.env.REACT_APP_DOMAIN;
    if (domain.startsWith('/') && domain !== '/') {
      return domain.replace(/^\//, '').replace(/\/$/, ''); // 移除开头和末尾斜杠
    }
  }
  return ''; // 本地开发时返回空字符串
};

// ✅ 合并为一个默认导出函数
export default function App(props) {
    useEffect(() => {
        // ✅ 初始化环境配置
        const initializeEnvironment = () => {
            // 从环境变量或配置确定环境
            const clientId = process.env.REACT_APP_CLIENT_ID || 'client-b';
            localStorage.setItem('clientId', clientId);
            
        };
        
        initializeEnvironment();
    }, []);
    
    return (
        <div className="App">
            <RecoilRoot>
                <ConfigProvider>
                    <StoreProvider>
                        <BrowserRouter basename={getBasename()}>
                            <ErrorBoundary>
                                <AnimationProvider>
                                    <RouterQuery />
                                    <Layouts>
                                        <Routes />
                                    </Layouts>
                                </AnimationProvider>
                            </ErrorBoundary>
                        </BrowserRouter>
                    </StoreProvider>
                </ConfigProvider>
            </RecoilRoot>
        </div>
    )
}

